// 图片文件对应魔数
const imgFileType: Record<string, any> = {
    jpeg: 'ffd8ff',
    jpg: 'ffd8ff',
    png: '89504E47',
    gif: '47494638',
    webp: '52494646',
}

// 返回六位数长度的16进制数
export const getFileHex = async (src: string): Promise<string> => {
    let hex = ''
    await loadFile(src).then((xhr) => {
        hex = bufToHex(xhr.response, 6)
    }).catch(() => {
        hex = ''
    })
    return hex
}

export const isImgFile = async (src: string): Promise<boolean> => {
    // 初步判断
    const isImg = /\.jpg|gif|png|webp|jpeg$/.test(src);
    const isVideo = /\.swf|flv|mp4|rmvb|avi|mpeg|ra|ram|mov|wmv|webm$/.test(src);
    if (isImg) {
        return true;
    }
    if (isVideo) {
        return false;
    }
    // 再通过文件魔数检查
    const fileHex = await getFileHex(src)
    for (let key in imgFileType) {
        if (imgFileType[key].indexOf(fileHex) > -1) {
            return true
        }
    }
    return false
}
export const isVideoUrl = (url: string): boolean => {
    return /\.(swf|flv|mp4|rmvb|avi|mpeg|ra|ram|mov|wmv|webm|m3u8)$/i.test(url.replace(/[?#].*$/, ''));
}

export const transToBase64 = (file: File): Promise<string> => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        // @ts-ignore
        reader.onload = () => resolve(reader.result || '');
        reader.onerror = error => reject(error);
    });
};

// Blob => ArrayBuffer（可指定指定长度）
export const readBuffer = (
    file: File,
    options?: { start?: number, end?: number }
): Promise<ArrayBuffer | null | string> => {
    const {
        start = 0,
        end = -1
    } = options || {}

    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => {
            resolve(reader.result)
        };
        reader.onerror = reject;
        reader.readAsArrayBuffer(file.slice(start, end))
    })
}

export const loadFile = (
    url: string,
    params?: {
        responseType?: XMLHttpRequestResponseType
    }
): Promise<XMLHttpRequest> => {
    const {
        responseType = 'arraybuffer'
    } = params || {}

    return new Promise((resolve, reject) => {
        const xhr = new XMLHttpRequest()
        // xhr.onload = () => {}
        xhr.onreadystatechange = () => {
            if (xhr.readyState === 4) {
                resolve(xhr)
            }
        }
        xhr.onerror = reject
        xhr.open('GET', url, true)
        xhr.responseType = responseType  // 类型
        // xhr.responseType = 'blob'
        xhr.send('')
    })
}

export const getFileFromUrl = (url: string, params?: {
    fileName?: string,
    responseType?: XMLHttpRequestResponseType
}): Promise<File> => {
    const {
        fileName = 'fileName',
        ...rest
    } = params || {}

    return new Promise((resolve, reject) => {
        let blob = null;
        loadFile(url, rest).then((xhr: XMLHttpRequest) => {
            blob = new Blob([xhr.response]); // arraybuffer 转 blob
            let file = new File([blob], fileName, {});

            resolve(file)
        }).catch(e => {
            reject(e)
        })
    })
}

// 通过文件地址URL，将所指文件转为File文件对象
/*export const getFileFromUrl = (url: string, fileName: string): Promise<File> => {
    return new Promise((resolve, reject) => {
        let blob = null;
        let xhr = new XMLHttpRequest();
        xhr.open("GET", url);
        xhr.setRequestHeader('Accept', 'image/png');
        xhr.responseType = "blob";
        // xhr.responseType = "arraybuffer";
        // 加载时处理
        xhr.onload = () => {
            // 获取返回结果
            blob = xhr.response;
            let file = new File([blob], fileName, { type: 'image/png' });
            // 返回结果
            resolve(file);
        };
        xhr.onerror = (e) => {
            reject(e)
        };
        // 发送
        xhr.send();
    });
}*/

// buffer 转 16 进制字符串
export const bufToHex = (buffer: ArrayBuffer, end = -1) => {
    return Array.prototype.map.call(
        new Uint8Array(buffer), x => ('00' + x.toString(16)).slice(-2)
    ).join('').slice(0, end)
}

